import { getConfiguration } from "@src/api/serviceIntegrations";
import { updateConfig } from "@store/serviceIntegrations/integrationForm/actions";
import { get } from "lodash";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { message } from 'antd';


function useGetConfig({ configId = null }) {

  const dispatch = useDispatch();

  const { isLoading, isFetching } = useQuery(['service-integration', configId],
    () => getConfiguration({ configId }), {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!configId,
    onSuccess: (response) => {
      const config = get(response, ['data', 'data']);
      dispatch(updateConfig(config));
    },
    onError: (error: any) => {
      message.error(error.message || 'Unknown error!');
    }
  }
  );

  return { isLoading: isLoading || isFetching }
}

export default useGetConfig;
